import React, { useState, useEffect, useRef } from "react";
import Base from "../../Config/Base";
import { Spinner } from "react-bootstrap";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import { useLocation } from "react-router-dom";
import * as lamejs from "@breezystack/lamejs";

import { Upload, Button, Tag, Space, message, Tooltip, Select } from "antd";

import {
  PaperClipOutlined,
  CameraOutlined,
  AudioOutlined,
  DeleteOutlined,
  LoadingOutlined,
  CloseOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Footer } from "../footer/footer";
import Swal from "sweetalert2";

import imageCompression from "browser-image-compression";
const fallbackCenter = { lat: 17.385, lng: 78.4867 }; // Hyderabad, used if geolocation fails
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Builds a Google Maps URL from lat/lng, e.g. https://www.google.com/maps?q=17.385,78.4867
const buildMapsUrl = (loc) =>
  `https://www.google.com/maps?q=${loc.lat},${loc.lng}`;

const MapUpdater = ({ position }) => {
  const map = useMap();

  useEffect(() => {
    const lat = Number(position?.lat);
    const lng = Number(position?.lng);

    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      map.setView([lat, lng], 15);
    }
  }, [position, map]);

  return null;
};

const LeafletMap = ({ position }) => {
  const lat = Number(position?.lat);
  const lng = Number(position?.lng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          height: "300px",
          width: "100%",
          borderRadius: "8px",
          background: "#f5f5f5",
          color: "#777",
        }}
      >
        Location not available
      </div>
    );
  }

  return (
    <MapContainer
      center={[lat, lng]}
      zoom={15}
      style={{
        height: "300px",
        width: "100%",
        borderRadius: "8px",
      }}
    >
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <MapUpdater position={{ lat, lng }} />

      <Marker position={[lat, lng]} />
    </MapContainer>
  );
};
const VisitNotes = () => {
  const location = useLocation();

  const visitType = location.state?.type;

  console.log("Visit Type:", visitType);

  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    setUserDetails(userDetailsSession);
  }, []);

  // Dropdown state
  const [relType, setRelType] = useState("Lead"); // "Lead" | "Customer"
  const [relOptions, setRelOptions] = useState([]);
  const [relId, setRelId] = useState("");
  const [loadingOptions, setLoadingOptions] = useState(false);

  // Location state
  const [currentLocation, setCurrentLocation] = useState(null);
  const [locatingUser, setLocatingUser] = useState(true);
  const [customMode, setCustomMode] = useState(false);
  const [customMapsUrl, setCustomMapsUrl] = useState("");

  // Shared notes field, appended after the maps URL in the payload
  const [notes, setNotes] = useState("");

  const [submitting, setSubmitting] = useState(false);

  // ---------------------------------------
  // Attachments
  // ---------------------------------------
  const [fileList, setFileList] = useState([]);

  // ---------------------------------------
  // Voice recording
  // ---------------------------------------
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);

  // Voice preview
  const [voicePreview, setVoicePreview] = useState(null);
  const [voiceFile, setVoiceFile] = useState(null);

  // MediaRecorder refs
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const timerRef = useRef(null);

  const [mapLocation, setMapLocation] = useState(null);
  const [mapAddress, setMapAddress] = useState("");
  const [loadingAddress, setLoadingAddress] = useState(false);

  const [locationError, setLocationError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const getCurrentLocation = () => {
      setLocatingUser(true);
      setLocationError("");

      if (!navigator.geolocation) {
        setLocationError("Your browser does not support location access.");
        setLocatingUser(false);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          if (!isMounted) return;

          const location = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          console.log("Current latitude:", location.lat);
          console.log("Current longitude:", location.lng);
          console.log("Location accuracy:", pos.coords.accuracy, "meters");

          setCurrentLocation(location);
          setMapLocation(location);

          try {
            await getAddress(location.lat, location.lng);
          } finally {
            if (isMounted) setLocatingUser(false);
          }
        },
        (err) => {
          if (!isMounted) return;

          console.error("Geolocation error:", err.code, err.message);

          const errors = {
            1: "Location permission denied. Allow location access in your browser settings.",
            2: "Your current location is unavailable. Check GPS or network connectivity.",
            3: "Location request timed out. Please try again.",
          };

          setLocationError(
            errors[err.code] || "Unable to retrieve your current location.",
          );

          // Do not treat Hyderabad as the user's actual location.
          setCurrentLocation(null);
          setMapLocation(null);
          setLocatingUser(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 20000,
          maximumAge: 0,
        },
      );
    };

    getCurrentLocation();

    return () => {
      isMounted = false;
    };
  }, []);

  // ---- Fetch Lead/Customer options whenever the type changes ----------
  useEffect(() => {
    fetchOptions(relType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relType]);

  // ---------------------------------------
  // Cleanup voice preview/timer
  // ---------------------------------------
  useEffect(() => {
    return () => {
      if (voicePreview) {
        URL.revokeObjectURL(voicePreview);
      }

      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [voicePreview]);

  useEffect(() => {
    if (visitType) {
      setRelType(visitType.toLowerCase() === "customer" ? "Customer" : "Lead");
    }
  }, [visitType]);

  // ---------------------------------------
  // Normal file upload
  // ---------------------------------------
  const MAX_FILE_SIZE = 300 * 1024; // 300 KB
  const MAX_IMAGE_SIZE = 100 * 1024; // 100kb
  const MAX_RECORDING_TIME = 180;

  const handleFileBeforeUpload = async (file) => {
    const isImage = file.type.startsWith("image/");
    const isPdf = file.type === "application/pdf";

    // Compress images to approximately 100 KB
    if (isImage) {
      try {
        const compressedBlob = await imageCompression(file, {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 1280,
          useWebWorker: true,
          initialQuality: 0.7,
        });

        if (compressedBlob.size > MAX_IMAGE_SIZE) {
          message.error(
            "Image could not be reduced to 100 KB. Please select another image.",
          );
          return Upload.LIST_IGNORE;
        }

        // Preserve the compressed image's format and extension
        const compressedFile = new File([compressedBlob], file.name, {
          type: compressedBlob.type,
          lastModified: Date.now(),
        });

        setFileList((prev) => [
          ...prev,
          {
            uid: file.uid,
            name: compressedFile.name,
            status: "done",
            originFileObj: compressedFile,
          },
        ]);

        message.success(
          `Image compressed to ${(compressedFile.size / 1024).toFixed(1)} KB`,
        );

        return false;
      } catch (error) {
        console.error("Image compression failed:", error);
        message.error("Failed to compress image. Please try again.");
        return Upload.LIST_IGNORE;
      }
    }

    // PDFs and other files must be 300 KB or smaller
    if (file.size > MAX_FILE_SIZE) {
      message.error(
        `${file.name} is too large. PDFs and other files must be 300 KB or smaller.`,
      );
      return Upload.LIST_IGNORE;
    }

    setFileList((prev) => [
      ...prev,
      {
        uid: file.uid,
        name: file.name,
        status: "done",
        originFileObj: file,
      },
    ]);

    return false;
  };

  const handleImageBeforeUpload = async (file) => {
    if (!file.type.startsWith("image/")) {
      message.error("Please select an image file.");
      return Upload.LIST_IGNORE;
    }

    try {
      message.loading({
        content: "Compressing image...",
        key: "imageCompression",
      });

      const options = {
        maxSizeMB: 0.1, // Target approximately 100 KB
        maxWidthOrHeight: 1280,
        useWebWorker: true,
        initialQuality: 0.7,
        fileType: "image/jpeg",
      };

      const compressedBlob = await imageCompression(file, options);

      // Ensure the compressed image has a .jpg filename
      const compressedFile = new File(
        [compressedBlob],
        `${file.name.replace(/\.[^/.]+$/, "")}.jpg`,
        {
          type: "image/jpeg",
          lastModified: Date.now(),
        },
      );

      // Enforce the 100 KB limit
      if (compressedFile.size > MAX_IMAGE_SIZE) {
        message.error(
          "Image is still larger than 100 KB. Please take another photo.",
        );
        return Upload.LIST_IGNORE;
      }

      setFileList((prev) => [
        ...prev,
        {
          uid: file.uid,
          name: compressedFile.name,
          status: "done",
          originFileObj: compressedFile,
        },
      ]);

      message.success({
        content: `Image compressed to ${(compressedFile.size / 1024).toFixed(1)} KB`,
        key: "imageCompression",
      });

      return false;
    } catch (error) {
      console.error("Image compression failed:", error);

      message.error({
        content: "Failed to compress image. Please try again.",
        key: "imageCompression",
      });

      return Upload.LIST_IGNORE;
    }
  };

  const startRecording = async () => {
    try {
      if (voicePreview) {
        URL.revokeObjectURL(voicePreview);
      }

      setVoicePreview(null);
      setVoiceFile(null);

      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });

      const recorder = new MediaRecorder(stream);

      mediaRecorderRef.current = recorder;
      audioChunksRef.current = [];

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      recorder.onstop = async () => {
        try {
          const audioBlob = new Blob(audioChunksRef.current, {
            type: recorder.mimeType || "audio/webm",
          });

          const audioBuffer = await audioBlob.arrayBuffer();

          const audioContext = new AudioContext();
          const decodedAudio = await audioContext.decodeAudioData(audioBuffer);

          const channelData = decodedAudio.getChannelData(0);
          const sampleRate = decodedAudio.sampleRate;

          const Mp3Encoder = lamejs.Mp3Encoder || lamejs.default?.Mp3Encoder;

          const mp3Encoder = new lamejs.Mp3Encoder(1, sampleRate, 128);

          const sampleBlockSize = 1152;
          const mp3Data = [];

          const samples = new Int16Array(channelData.length);

          for (let i = 0; i < channelData.length; i++) {
            const sample = Math.max(-1, Math.min(1, channelData[i]));
            samples[i] = sample < 0 ? sample * 32768 : sample * 32767;
          }

          for (let i = 0; i < samples.length; i += sampleBlockSize) {
            const sampleChunk = samples.subarray(i, i + sampleBlockSize);
            const mp3Chunk = mp3Encoder.encodeBuffer(sampleChunk);

            if (mp3Chunk.length > 0) {
              mp3Data.push(mp3Chunk);
            }
          }

          const finalChunk = mp3Encoder.flush();

          if (finalChunk.length > 0) {
            mp3Data.push(finalChunk);
          }

          const mp3Blob = new Blob(mp3Data, { type: "audio/mpeg" });

          const newVoiceFile = new File(
            [mp3Blob],
            `voice_visit_${Date.now()}.mp3`,
            { type: "audio/mpeg" },
          );

          const previewUrl = URL.createObjectURL(mp3Blob);

          setVoiceFile(newVoiceFile);
          setVoicePreview(previewUrl);

          await audioContext.close();
        } catch (error) {
          console.error("MP3 conversion failed:", error);
          message.error("Failed to convert recording to MP3.");
        } finally {
          stream.getTracks().forEach((track) => track.stop());
          setRecordingTime(0);
          setIsRecording(false);
        }
      };

      recorder.start();

      setIsRecording(true);
      setRecordingTime(0);

      timerRef.current = setInterval(() => {
        setRecordingTime((prev) => {
          const nextTime = prev + 1;

          // Automatically stop at 180 seconds
          if (nextTime >= MAX_RECORDING_TIME) {
            clearInterval(timerRef.current);

            // Stop recording
            if (mediaRecorderRef.current?.state === "recording") {
              mediaRecorderRef.current.stop();
            }

            setIsRecording(false);

            message.info("Maximum recording time of 180 seconds reached.");

            return MAX_RECORDING_TIME;
          }

          return nextTime;
        });
      }, 1000);
    } catch (error) {
      console.error("Microphone access denied:", error);

      message.error(
        "Could not access microphone. Please allow microphone permission.",
      );
    }
  };

  // ---------------------------------------
  // Stop voice recording
  // ---------------------------------------
  const stopRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();

      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }

      setIsRecording(false);
    }
  };

  // ---------------------------------------
  // Remove voice recording
  // ---------------------------------------
  const removeVoiceRecording = () => {
    if (voicePreview) {
      URL.revokeObjectURL(voicePreview);
    }

    setVoicePreview(null);
    setVoiceFile(null);
    setRecordingTime(0);
  };

  const fetchOptions = async (type) => {
    setLoadingOptions(true);
    setRelId("");
    try {
      const endpoint =
        type === "Lead" ? "leads/GetLeads" : "customers/GetCustomers";
      const res = await axios.get(`${API_BASE_CRM_URL}${endpoint}`);
      const data = res?.data?.ResultData || [];

      const normalized =
        type === "Lead"
          ? data.map((item) => ({
              id: item.id,
              label: `${item.name}${item.company ? " - " + item.company : ""}`,
            }))
          : data.map((item) => ({
              id: item.customerId,
              label: `${item.company}${item.contactName ? " - " + item.contactName : ""}`,
            }));

      setRelOptions(normalized);
    } catch (err) {
      console.error("Failed to fetch " + type + " options:", err);
      setRelOptions([]);
    } finally {
      setLoadingOptions(false);
    }
  };

  const handleMapsUrlChange = async (e) => {
    const url = e.target.value.trim();

    setCustomMapsUrl(url);

    if (!url) {
      setMapLocation(null);
      setMapAddress("");
      return;
    }

    // -----------------------------------------
    // 1. Direct Google Maps coordinate URL
    // -----------------------------------------
    let match = url.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);

    // Example:
    // https://www.google.com/maps?q=17.385,78.4867
    if (!match) {
      match = url.match(/[?&]q=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    }

    // Example:
    // !3d17.385!4d78.4867
    if (!match) {
      match = url.match(/!3d(-?\d+(?:\.\d+))!4d(-?\d+(?:\.\d+))/);
    }

    if (match) {
      const lat = parseFloat(match[1]);
      const lng = parseFloat(match[2]);

      if (Number.isFinite(lat) && Number.isFinite(lng)) {
        console.log("Direct Google coordinates:", lat, lng);

        setMapLocation({
          lat,
          lng,
        });

        await getAddress(lat, lng);
        return;
      }
    }

    // -----------------------------------------
    // 2. Google short URL
    // -----------------------------------------
    if (url.includes("maps.app.goo.gl")) {
      try {
        setLoadingAddress(true);
        setMapAddress("");

        console.log("Resolving short Google Maps URL:", url);

        const response = await axios.post(
          `${API_BASE_CRM_URL}resolve-google-map`,
          {
            url,
          },
        );

        console.log("Google Maps resolve response:", response.data);

        const { lat, lng } = response.data;

        if (Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
          const location = {
            lat: Number(lat),
            lng: Number(lng),
          };

          setMapLocation(location);

          await getAddress(Number(lat), Number(lng));
        } else {
          setMapAddress("Unable to find location from this Google Maps link.");
        }
      } catch (error) {
        console.error("Google Maps URL resolve error:", error);

        setMapAddress("Unable to resolve this Google Maps link.");
      } finally {
        setLoadingAddress(false);
      }

      return;
    }

    console.log("No coordinates found in URL");
  };

  const getAddress = async (lat, lng) => {
    try {
      setLoadingAddress(true);
      setMapAddress("");

      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
        {
          headers: {
            Accept: "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to get address");
      }

      const data = await response.json();

      setMapAddress(data.display_name || "Address not found");
    } catch (error) {
      console.error("Address error:", error);
      setMapAddress("Unable to get address");
    } finally {
      setLoadingAddress(false);
    }
  };
  // ---- Submit -----------------------------------------------------------
  const handleSubmit = async (useCurrent) => {
    if (!relId) {
      alert(`Please select a ${relType.toLowerCase()}`);
      return;
    }

    let mapsUrl;

    if (useCurrent) {
      if (!currentLocation) {
        alert(
          "Location is not available yet, please wait a moment and try again",
        );
        return;
      }

      mapsUrl = buildMapsUrl(currentLocation);
    } else {
      if (!customMapsUrl.trim()) {
        alert("Please paste a Google Maps URL");
        return;
      }

      mapsUrl = customMapsUrl.trim();
    }

    setSubmitting(true);

    try {
      const description = `${mapsUrl},${notes}`;

      const formData = new FormData();

      formData.append("rel_id", relId);
      formData.append("rel_type", relType);
      formData.append("description", description);
      formData.append("addedfrom", userDetails?.staffid);

      fileList.forEach((file) => {
        if (file.originFileObj) {
          formData.append("files", file.originFileObj);
        }
      });

      if (voiceFile) {
        formData.append("files", voiceFile);
      }

      const response = await axios.post(
        `${API_BASE_CRM_URL}notes/AddNotenew`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            response.data.Message || "Visit location submitted successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        // Reset
        setRelId("");
        setCustomMode(false);
        setCustomMapsUrl("");
        setNotes("");

        // Reset attachments
        setFileList([]);

        // Reset voice
        removeVoiceRecording();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.Message || "Failed to add location",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      console.error("Failed to submit visit:", err);

      // Log the actual backend response
      console.error("Error status:", err?.response?.status);
      console.error("Error response:", err?.response?.data);
      console.error("Request URL:", err?.config?.url);

      const errorMessage =
        err?.response?.data?.Message ||
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Failed to submit visit location, please try again";

      alert(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Base>
        <div
          className="container"
          style={{
            // minHeight: "100vh",
            marginBottom: fileList?.length > 0 ? "100px" : "0px",
          }}
        >
          <div className="page-title">
            <h4>Log Visit Notes</h4>
          </div>
          <hr />

          {!customMode ? (
            locatingUser || !currentLocation ? (
              <div className="text-center py-5">
                <Spinner animation="border" />
                <div className="mt-2">Fetching current location...</div>
              </div>
            ) : (
              <>
                <LeafletMap position={currentLocation} />

                {!loadingAddress && mapAddress && (
                  <div
                    className="fw-semibold mt-2"
                    style={{ color: "#1B2850" }}
                  >
                    Location:{" "}
                    {(() => {
                      try {
                        const parts = mapAddress
                          .split(",")
                          .map((item) => item.trim());
                        return parts.slice(0, 3).join(", ");
                      } catch {
                        return mapAddress;
                      }
                    })()}
                  </div>
                )}
              </>
            )
          ) : (
            <div className="mt-3">
              <LeafletMap position={mapLocation} />
              {!loadingAddress && mapAddress && (
                <div className="fw-semibold mt-2" style={{ color: "#1B2850" }}>
                  Location:{" "}
                  {(() => {
                    try {
                      const parts = mapAddress
                        .split(",")
                        .map((item) => item.trim());
                      return parts.slice(0, 3).join(", ");
                    } catch {
                      return mapAddress;
                    }
                  })()}
                </div>
              )}

              <label className="form-label mt-3" style={{ fontSize: "13px" }}>
                Google Maps URL
              </label>

              <input
                type="url"
                className="form-control"
                placeholder="Paste a Google Maps link"
                value={customMapsUrl}
                onChange={handleMapsUrlChange}
                disabled={submitting}
              />

              <div className="text-muted mt-1" style={{ fontSize: "12px" }}>
                Paste a Google Maps location link to automatically show the
                location on the map.
              </div>

              {loadingAddress && (
                <div className="mt-2 text-muted" style={{ fontSize: "13px" }}>
                  Getting address...
                </div>
              )}
            </div>
          )}

          <div className="row g-2 mt-1">
            <div className="col-12">
              <label className="form-label" style={{ fontSize: "13px" }}>
                {relType}
              </label>

              <Select
                showSearch
                className="w-100"
                placeholder={`Select ${relType}`}
                value={relId || undefined}
                onChange={(value) => setRelId(value)}
                disabled={loadingOptions || submitting}
                loading={loadingOptions}
                allowClear
                optionFilterProp="label"
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
                options={relOptions.map((opt) => ({
                  value: opt.id,
                  label: opt.label,
                }))}
                style={{ height: 38 }}
              />
            </div>

            <div
              className="d-flex align-items-center justify-content-between p-2 mb-3"
              style={{
                background: "#f5f5f5",
                borderRadius: "8px",
                border: "1px solid #d9d9d9",
              }}
            >
              <div className="d-flex align-items-center">
                {isRecording ? (
                  <div className="d-flex align-items-center text-danger">
                    <LoadingOutlined className="me-2" />

                    <span className="fw-bold me-2">
                      Recording ({recordingTime}s) /(180s)
                    </span>

                    <Tooltip title="Stop Recording">
                      <Button
                        type="primary"
                        danger
                        size="small"
                        onClick={stopRecording}
                      >
                        <CloseOutlined />
                      </Button>
                    </Tooltip>
                  </div>
                ) : (
                  <Space size="middle">
                    <Upload
                      beforeUpload={handleFileBeforeUpload}
                      showUploadList={false}
                      multiple
                      disabled={submitting || isRecording}
                    >
                      <Tooltip title="Attach File - Max 300 KB">
                        <Button
                          type="text"
                          icon={
                            <PaperClipOutlined
                              style={{
                                fontSize: "18px",
                                color: "#1B2850",
                              }}
                            />
                          }
                        />
                      </Tooltip>
                    </Upload>

                    <Upload
                      beforeUpload={handleImageBeforeUpload}
                      showUploadList={false}
                      accept="image/*"
                      capture="environment"
                      disabled={submitting || isRecording}
                    >
                      <Tooltip title="Upload / Take Photo - Max 100 KB">
                        <Button
                          type="text"
                          icon={
                            <CameraOutlined
                              style={{
                                fontSize: "18px",
                                color: "#1B2850",
                              }}
                            />
                          }
                        />
                      </Tooltip>
                    </Upload>

                    <Tooltip title="Record Voice">
                      <Button
                        type="text"
                        icon={
                          <AudioOutlined
                            style={{
                              fontSize: "18px",
                              color: "#1B2850",
                            }}
                          />
                        }
                        onClick={startRecording}
                      />
                    </Tooltip>
                  </Space>
                )}
              </div>

              <span
                style={{
                  fontSize: "12px",
                  color: "#8c8c8c",
                }}
              >
                Add attachment
              </span>
            </div>

            {/* ---------------------------------
    Voice Preview
---------------------------------- */}
            {voicePreview && voiceFile && (
              <div
                className=" p-2"
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "8px",
                  background: "#fafafa",
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div className="d-flex align-items-center">
                    <PlayCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: "#1B2850",
                        marginRight: "8px",
                      }}
                    />

                    <span
                      style={{
                        fontWeight: 600,
                        color: "#1B2850",
                      }}
                    >
                      Voice Message
                    </span>
                  </div>

                  <Tooltip title="Remove Voice Recording">
                    <Button
                      type="text"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={removeVoiceRecording}
                    />
                  </Tooltip>
                </div>

                <audio
                  controls
                  src={voicePreview}
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                />
              </div>
            )}

            {fileList.length > 0 && (
              <div className="">
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#1B2850",
                    marginBottom: "8px",
                  }}
                >
                  Attachments ({fileList.length})
                </div>

                <div className="d-flex flex-wrap gap-2">
                  {fileList.map((file) => (
                    <Tag
                      key={file.uid}
                      closable
                      onClose={() => {
                        setFileList((prev) =>
                          prev.filter((item) => item.uid !== file.uid),
                        );
                      }}
                      style={{
                        padding: "5px 8px",
                        fontSize: "12px",
                      }}
                    >
                      {file.originFileObj?.type?.startsWith("image/")
                        ? "📷 "
                        : "📎 "}
                      {file.name}
                    </Tag>
                  ))}
                </div>
              </div>
            )}
            <div className="col-12 mb-0 ">
              <label className="form-label" style={{ fontSize: "13px" }}>
                Note
              </label>
              <textarea
                className="form-control"
                placeholder="Notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                disabled={submitting}
              />
            </div>
          </div>

          {!customMode ? (
            <div className="d-flex justify-content-end w-100 mt-1">
              <button
                className="btn btn-sm btn-secondary me-2"
                onClick={() => {
                  setCustomMode(true);

                  if (currentLocation) {
                    setMapLocation(currentLocation);
                    getAddress(currentLocation.lat, currentLocation.lng);
                  }
                }}
                disabled={submitting}
              >
                <i className="fa-solid fa-location-dot me-1"></i>Location
              </button>
              <button
                className="btn btn-sm btn-success"
                onClick={() => handleSubmit(true)}
                disabled={submitting || !currentLocation}
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          ) : (
            <div className="d-flex justify-content-end w-100 mt-1">
              <button
                className="btn btn-sm btn-secondary me-2"
                onClick={() => setCustomMode(false)}
                disabled={submitting}
              >
                Back
              </button>
              <button
                className="btn btn-sm btn-success "
                onClick={() => handleSubmit(false)}
                disabled={submitting || !customMapsUrl.trim()}
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          )}
        </div>
      </Base>
      <Footer />
    </>
  );
};

export default VisitNotes;
